import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getCategories } from "../../redux/actions/category";
import { getSubcategories } from "../../redux/actions/Subcategory";
import { getSubSubcategories } from "../../redux/actions/subsubcategory";
import { FiChevronLeft } from "react-icons/fi";
import "./Navbar.scss";

const Navbar = ({ onClose }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getSubcategories());
    dispatch(getSubSubcategories());
  }, [dispatch]);

  const { categories = [] } = useSelector((state) => state.category || {});
  const { subcategories = [] } = useSelector(
    (state) => state.subcategories || {}
  );
  const { subsubcategories = [] } = useSelector(
    (state) => state.subsubcategories || {}
  );
  const [currentLevel, setCurrentLevel] = useState("category");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const goToSubcategoryLevel = (categoryId) => {
    setSelectedCategory(categoryId);
    setSelectedSubcategory(null);
    setCurrentLevel("subcategory");
  };
  const goToSubSubcategoryLevel = (subcatId) => {
    setSelectedSubcategory(subcatId);
    setCurrentLevel("subsubcategory");
  };
  const goBack = () => {
    if (currentLevel === "subsubcategory") {
      setCurrentLevel("subcategory");
      setSelectedSubcategory(null);
    } else if (currentLevel === "subcategory") {
      setCurrentLevel("category");
      setSelectedCategory(null);
    }
  };
  const filteredSubcategories = subcategories.filter((subcat) =>
    subcat.parentCategories.some((parent) => parent._id === selectedCategory)
  );
  const filteredSubSubcategories = subsubcategories.filter((subsubcat) =>
    subsubcat.parentSubcategories.some(
      (parent) => parent._id === selectedSubcategory
    )
  );
  const parentCategory = categories.find((cat) => cat._id === selectedCategory);
  const parentSubcategoryObj = subcategories.find(
    (subcat) => subcat._id === selectedSubcategory
  );

  let content;
  if (currentLevel === "category") {
    content = (
      <>
        <h2 className="navbar-title">Категорії</h2>
        <ul>
          {categories.map((cat) => (
            <li key={cat._id} onClick={() => goToSubcategoryLevel(cat._id)}>
              <span>{cat.name}</span>
            </li>
          ))}
        </ul>
      </>
    );
  } else if (currentLevel === "subcategory") {
    content = (
      <>
        <div className="navbar-header">
          <button className="navbar-back-btn" onClick={goBack}>
            <FiChevronLeft />
          </button>
          <h2 className="navbar-title">
            {parentCategory ? (
              <Link to={`/products/${parentCategory._id}`}>
                {parentCategory.name}
              </Link>
            ) : (
              "Підкатегорії"
            )}
          </h2>
        </div>
        <ul>
          {filteredSubcategories.map((subcat) => (
            <li
              key={subcat._id}
              onClick={() => goToSubSubcategoryLevel(subcat._id)}
            >
              <span>{subcat.name}</span>
            </li>
          ))}
        </ul>
      </>
    );
  } else if (currentLevel === "subsubcategory") {
    content = (
      <>
        <div className="navbar-header">
          <button className="navbar-back-btn" onClick={goBack}>
            <FiChevronLeft />
          </button>
          <h2 className="navbar-title">
            {parentSubcategoryObj ? (
              <Link to={`/productss/${parentSubcategoryObj._id}`}>
                {parentSubcategoryObj.name}
              </Link>
            ) : (
              "Суб-субкатегорії"
            )}
          </h2>
        </div>
        <ul>
          {filteredSubSubcategories.map((subsubcat) => (
            <Link to={`/items/${subsubcat._id}`} key={subsubcat._id}>
              <li>
                <span>{subsubcat.name}</span>
              </li>
            </Link>
          ))}
        </ul>
      </>
    );
  }

  return (
    <div
      className="navbar-container"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="navbar-content">{content}</div>
    </div>
  );
};

export default Navbar;
